import { Component, computed, input, output, signal, TemplateRef } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'ui-tab',
  templateUrl: './tab.component.html',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
})
export class TabComponent {
  // Basic properties
  readonly label = input<string>('');

  // Template-based content
  readonly content = input<TemplateRef<unknown>>();

  // Router-based properties
  readonly routerLink = input<string | unknown[]>();

  // Events
  readonly tabClick = output<void>();

  // State
  readonly isActive = signal(false);

  // Computed properties
  readonly isRouterTab = computed(() => !!this.routerLink());
  readonly isTemplateTab = computed(() => !!this.content());

  setActive(active: boolean) {
    this.isActive.set(active);
  }
}
